import React from 'react'
import './index.scss'

interface IBgProps {
    closeMolul: () => void
}
class BgModul extends React.Component<IBgProps, any> {
    readonly module = React.createRef<HTMLDivElement>()
    componentDidMount() {
        this.module.current?.addEventListener('touchmove', e => {
            e.stopPropagation()
        })
        let node: HTMLDivElement | null = document.querySelector('.App')
        node?.classList.add('over')
    }
    componentWillUnmount() {
        let node: HTMLDivElement | null = document.querySelector('.App')
        this.module.current?.removeEventListener('touchmove', e => {
            e.stopPropagation()
        })
        node?.classList.remove('over')
    }
    render() {
        const { children, closeMolul } = this.props
        return (
            <div ref={this.module} className="bgModul" onClick={closeMolul}>
                <div
                    className="filterModul"
                    onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                >
                    {children}
                </div>
            </div>
        )
    }
}

export default BgModul
